import { combineReducers } from "redux";
import ReducerNamespaceTypes from "../../../../../enums/reducer/reducerNamespaceTypes";
import ReducerEntityPrefixTypes from "../../../../../enums/reducer/reducerEntityPrefixTypes";

import { withFetchingEntityListItems } from "../../../../Application/reducers/hoc/withFetchingItems";
import groupAssignmetFilterSlice from "../slice/GroupAssignmentFilterSlice";

const namespace = ReducerNamespaceTypes.Library;
const entityPrefix = ReducerEntityPrefixTypes.Group_Assignments;

const groupsAssignmentReducer = combineReducers({
  groupsToBeAssigned: withFetchingEntityListItems(namespace, entityPrefix),
  filter: groupAssignmetFilterSlice,
});

export default groupsAssignmentReducer;
